import React, { useEffect } from "react";

interface IAutoScrollTopComponentProps {
    changeDetector?: any;
}

export const AutoScrollTopComponent: React.FC<IAutoScrollTopComponentProps> = (
    props: IAutoScrollTopComponentProps
) => {
    const { changeDetector } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [changeDetector]);

    return <></>;
};
